import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Modal } from "react-responsive-modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusSquare, faBook, faCopy } from "@fortawesome/free-solid-svg-icons";
import Button from "components/CustomButton";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";

const CreateCourse = ({ team }) => {
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const [courseType, setCourseType] = useState("new");

  const handleClose = () => {
    setShowModal(false);
    setCourseType("new");
  };

  const handleShow = () => setShowModal(true);

  const handleCreate = () => {
    if (courseType === "new") {
      if (team) {
        // Team context - use the new creator component
        history.push(`/teams/${team?.id}/coursebuilder/create`);
      } else {
        // Global context
        history.push("/course-builder/create");
      }
    } else {
      // Template selection
      if (team) {
        // Team context
        history.push(`/teams/${team?.id}/coursebuilder/templates`);
      } else {
        // Global context
        history.push("/course-builder/templates");
      }
    }
    handleClose();
  };

  return (
    <>
      <Button onClick={handleShow} buttonClass="light-gray-btn d-inline-block mb-3">
        <FontAwesomeIcon icon={faPlusSquare} className="me-2" />
        Create Course
      </Button>

      <Modal
        open={showModal}
        onClose={handleClose}
        showCloseIcon={false}
        closeOnEsc={false}
        closeOnOverlayClick={false}
        classNames={{
          modalContainer: "modalContainer",
          modal: "createCourseModal",
        }}
      >
        <div className="modal fade popup-modal create-task-popup">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="text-center createTaskHeading">Create New Course</h5>
            <CloseIcon style={{ width: "20px", cursor: "pointer" }} onClick={handleClose} />
          </div>
          <div className="mb-4">
            <p>How would you like to get started?</p>
          </div>

          <div className="d-flex flex-column gap-3">
            <div 
              className={`card course-option p-3 ${courseType === "new" ? "border-primary" : ""}`}
              onClick={() => setCourseType("new")}
              style={{ cursor: "pointer" }}
            >
              <div className="d-flex align-items-center">
                <div className={`course-option-icon me-3 ${courseType === "new" ? "bg-primary text-white" : "bg-light"}`}>
                  <FontAwesomeIcon icon={faBook} />
                </div>
                <div>
                  <h6 className="mb-1">Start from scratch</h6>
                  <p className="mb-0 text-muted small">Create a completely new course with custom modules</p>
                </div>
              </div>
            </div>

            <div 
              className={`card course-option p-3 disabled ${courseType === "template" ? "border-primary" : ""}`}
              onClick={() => setCourseType("template")}
              style={{ cursor: "pointer" }}
            >
              <div className="d-flex align-items-center">
                <div className={`course-option-icon me-3 ${courseType === "template" ? "bg-primary text-white" : "bg-light"}`}>
                  <FontAwesomeIcon icon={faCopy} />
                </div>
                <div>
                  <h6 className="mb-1">Use a template</h6>
                  <p className="mb-0 text-muted small">Start with a pre-designed course structure</p>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-end mt-4">
            <Button buttonClass="btn-secondary me-2" onClick={handleClose}>
              Cancel
            </Button>
            <Button buttonClass="grad_btn" onClick={handleCreate}>
              Continue
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default CreateCourse;